/**
 * Safe HTML sanitizer used anywhere we need dangerouslySetInnerHTML.
 * Wraps DOMPurify with a sensible config: allows common formatting tags,
 * strips <script>, inline event handlers, <iframe>, <style>, etc.
 */
import DOMPurify from 'dompurify';

const DEFAULT_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'span', 'div', 'strong', 'em', 'b', 'i', 'u',
    'ul', 'ol', 'li',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'a', 'code', 'pre', 'blockquote',
    'table', 'thead', 'tbody', 'tr', 'td', 'th',
    'hr', 'img',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'src', 'alt', 'title'],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'],
};

export const sanitizeHtml = (html, extraConfig = {}) =>
  DOMPurify.sanitize(html ?? '', { ...DEFAULT_CONFIG, ...extraConfig });

/**
 * Produce the object shape React expects for dangerouslySetInnerHTML.
 * Usage:  <div dangerouslySetInnerHTML={safeHtml(content)} />
 */
export const safeHtml = (html, extraConfig = {}) => ({
  __html: sanitizeHtml(html, extraConfig),
});

export default sanitizeHtml;
